module.exports = __webpack_public_path__ + "static/media/google-play-badge.ccfbe4d5.png";